<template>
  <lazy-component tag="div" class="twitter-lazy-wrapper" ref="lazy">
    <div v-html="item.content.html"></div>
  </lazy-component>
</template>
<script>
import get from 'lodash/get'
import twitter from 'components/mixins/twitter'

export default {
  name: 'body-twitter',
  props: ['item'],
  mixins: [twitter],
  mounted() {
    this.$watch('$refs.lazy.state.loaded', () => {
      if (get(this, '$refs.lazy.state.loaded')) {
        this.loadTwitterScript()
      }
    })
  },
}
</script>



// WEBPACK FOOTER //
// Twitter.vue?8a9681ea